import React from "react"

import styles from "./Iframe.module.scss"

export interface IframeProps {
	src?: string
	alt?: string
	iframeContainerProp?: string
}

const Iframe: React.FC<IframeProps> = ({src, alt, iframeContainerProp}) => {
	const containerRef = React.useRef<HTMLDivElement | null>(null)

	React.useEffect(() => {
		if (!containerRef.current || !src || !alt) return

		containerRef.current.innerHTML = ""

		let useCustomPlayer = false
		const site = "https://dreambroker.com"
		let resource = src

		try {
			const url = new URL(src, site) // allows relative paths
			const match = url.pathname.match(
				/^\/channel\/([^/]+)\/iframe\/([^/]+)/,
			)

			if (match) {
				const [, channelId, videoId] = match
				resource = `${channelId}/${videoId}`
				useCustomPlayer = true
			}
		} catch (err) {
			console.warn("URL parsing failed, using fallback iframe for:", src)
		}

		const text = alt
			.replace(/<\/?(p|h[1-6]|br|div)[^>]*>/gi, " ")
			.replace(/<[^>]+>/g, "")
			.replace(/&[^;]+;/g, (m) => (m === "&amp;" ? "&" : ""))
			.replace(/[\r\n]+/g, " ")
			.replace(/\s{2,}/g, " ")
			.trim()

		if (useCustomPlayer) {
			const iframe = document.createElement(
				"dreambroker-studio-video-player",
			)
			// @ts-expect-error
			iframe.site = site
			// @ts-expect-error
			iframe.resource = resource
			iframe.title = text
			iframe.className = styles.iframe
			// @ts-expect-error
			iframe.width = "-1"
			// @ts-expect-error
			iframe.height = "-1"
			containerRef.current.appendChild(iframe)
		} else {
			const fallbackIframe = document.createElement("iframe")
			fallbackIframe.src = src
			fallbackIframe.title = text
			fallbackIframe.className = styles.iframe
			fallbackIframe.frameBorder = "0"
			fallbackIframe.allowFullscreen = true
			containerRef.current.appendChild(fallbackIframe)
		}

		return () => {
			if (containerRef.current) {
				containerRef.current.innerHTML = ""
			}
		}
	}, [src, alt])

	return (
		<div
			ref={containerRef}
			className={`${styles.iframeContainer} ${iframeContainerProp}`}
		/>
	)
}

export default Iframe
